import axios from 'axios'

import { CalculationServiceLogisticsApi } from '../../../publish/calculation/apis/calculation-service-logistics-api'
import { Configuration } from '../../../publish/calculation/configuration'
import { setupAxiosInterceptors } from '../../axios-interceptor-utils'

export class CalculationServiceLogistics extends CalculationServiceLogisticsApi {
  constructor(
    protected basePath: string,
    private getTokenFn?: () => Promise<string>,
  ) {
    super(new Configuration({ basePath: basePath }), basePath, axios.create())
    setupAxiosInterceptors(this.axios, this.getTokenFn)
  }
}
